import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  normalizeLocale,
  ROLEX_SERVICE_PROCEDURE_URL,
} from '../../utils/helpers/constants.helpers';

import './Procedure.scss';

const getRolexServiceProcedureUrl = (language) => {
  const locale = normalizeLocale(language).toLowerCase();

  return locale === 'en'
    ? ROLEX_SERVICE_PROCEDURE_URL.default
    : ROLEX_SERVICE_PROCEDURE_URL.localized.replace('{locale}', locale);
};

const Procedure = ({ rightToLeft, text }) => {
  const { t, i18n } = useTranslation();
  const procedureTitleRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const selectedLanguage = i18n.resolvedLanguage || i18n.language;
  const urlLink = getRolexServiceProcedureUrl(selectedLanguage);

  useEffect(() => {
    const procedureTitleElement = procedureTitleRef.current;

    if (!procedureTitleElement) {
      return undefined;
    }

    let isMounted = true;

    const updateOverflowState = () => {
      const hasOverflow =
        procedureTitleElement.scrollWidth > procedureTitleElement.clientWidth;

      if (isMounted) {
        setIsOverflowing(hasOverflow);
      }
    };

    updateOverflowState();

    const resizeObserver =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(updateOverflowState)
        : null;

    resizeObserver?.observe(procedureTitleElement);
    window.addEventListener('resize', updateOverflowState);
    document.fonts?.ready?.then(updateOverflowState);

    return () => {
      isMounted = false;
      resizeObserver?.disconnect();
      window.removeEventListener('resize', updateOverflowState);
    };
  }, [selectedLanguage, text]);

  return (
    <div className="procedureWrapper">
      <div className={rightToLeft ? 'blockRTL' : 'block'}>
        <div
          ref={procedureTitleRef}
          className="procedureWrapperHeader"
          style={{ fontSize: isOverflowing ? '17px' : '20px' }}
        >
          <h2>{text}</h2>
        </div>

        <a
          href={urlLink}
          title={t('accessibility.serviceCentreTitle')}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('discoverButton')}
        >
          {t('discoverButton')}
        </a>
      </div>
    </div>
  );
};

export default Procedure;
